// extracted by mini-css-extract-plugin
module.exports = {"videosList":"VideosList_videosList__3zti7"};